<template>
  <b-tab :title="title" lazy class="tab__user_dashboard">
    <template slot="title">
      <span ref="title" class="font-size-md active span__publication-todo-tab mr-2">{{
        title
      }}</span>

      <div class="divider" />
    </template>

    <div class="mb-3">
      <BaseFilterStatusSubmission
        v-model="filterOption"
        :show="showFilter"
        :static-stats="userStatSubmission"
        static
        @change="setItems"
      />
    </div>

    <div>
      <ListCardMc :items="items"></ListCardMc>
    </div>
  </b-tab>
</template>

<script>
import EvidenceSubmission from '@/models/EvidenceSubmission';
import ListCardMc from './ListCardMc.vue';
import BaseFilterStatusSubmission from '@/components/base-components/BaseFilterStatusSubmission.vue';

export default {
  components: {
    BaseFilterStatusSubmission,
    ListCardMc
  },
  props: {
    title: {
      type: String,
      default: 'All'
    },

    dashboard: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      items: [],
      filterOption: 'ALL',
      showFilter: [
        'All',
        EvidenceSubmission.STATUS.NOT_SUBMITTED,
        EvidenceSubmission.STATUS.REVIEW_PENDING,
        EvidenceSubmission.STATUS.ACHIEVED,
        EvidenceSubmission.STATUS.DENIED
      ]
    };
  },

  computed: {
    userStatSubmission() {
      const { dashboard = [] } = this;

      const items = {
        total_submissions: 0,
        total_not_submitted: 0,
        total_review_pending: 0,
        total_achieved: 0,
        total_denied: 0
      };

      if (dashboard.length) {
        dashboard.forEach(({ status } = {}) => {
          items.total_submissions += 1;

          if (status) {
            switch (status) {
              case 'NOT_SUBMITTED':
                items.total_not_submitted += 1;
                break;

              case 'REVIEW_PENDING':
                items.total_review_pending += 1;
                break;

              case 'AWARDED':
                items.total_achieved += 1;
                break;

              case 'DENIED':
                items.total_denied += 1;
                break;
            }
          }
        });
      }

      return items;
    }
  },

  watch: {
    dashboard: {
      immediate: true,
      handler: 'setItems'
    }
  },

  methods: {
    setItems() {
      if (this.filterOption == 'ALL') {
        this.items = [...this.dashboard];
      } else {
        this.items = this.dashboard.filter((d) => d.status == this.filterOption);
      }
    }
  }
};
</script>
